import React from 'react';

const SubscriptionBanner: React.FC = () => {
  // This component is now empty as we're removing the top notification bar
  // The subscription status is now only shown in the sidebar
  return null;
};

export default SubscriptionBanner;